import { render, staticRenderFns } from "./LiveReport.vue?vue&type=template&id=965291c8&scoped=true&"
import script from "./LiveReport.vue?vue&type=script&lang=js&"
export * from "./LiveReport.vue?vue&type=script&lang=js&"
import style0 from "./LiveReport.vue?vue&type=style&index=0&id=965291c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965291c8",
  null
  
)

export default component.exports